import React, { FC } from "react"
import styled from "styled-components"

import { CardFragmentFragment, PostContentReferencesFragmentFragment } from "@graphqlTypes"

import CTA from "@components/CTA/CTA"

import BespokeComponent from "@components/lp/BespokeComponent/BespokeComponent"
import ContentBlockquote from "../ContentBlockquote/ContentBlockquote"
import ContentBreakout from "../ContentBreakout/ContentBreakout"
import ContentCallout from "../ContentCallout/ContentCallout"
import ContentImages from "../ContentImages/ContentImages"
import ContentRelatedContent from "../ContentRelatedContent/ContentRelatedContent"
import ContentTable from "../ContentTable/ContentTable"
import ContentTextWithImg from "../ContentTextWithImg/ContentTextWithImg"
import ContentVideo from "../ContentVideo/ContentVideo"

import AccordionBlock from "@components/lp/AccordionBlock/AccordionBlock"
import { ACCORDION_SIZES } from "@components/Accordion/Accordion"

const CONTENT_COMPONENTS = {
  "ContentfulContentBlockBlockquote": ContentBlockquote,
  "ContentfulContentBlockCallout": ContentCallout,
  "ContentfulContentBlockImages": ContentImages,
  "ContentfulContentBlockRelatedContent": ContentRelatedContent,
  "ContentfulContentBlockTable": ContentTable,
  "ContentfulContentBlockTextWithImage": ContentTextWithImg,
  "ContentfulContentBlockVideo": ContentVideo,
  "ContentfulLpAccordionBlock": (props: any) => (
    <ContentBreakout>
      <AccordionBlock
        {...props}
        // Override any props that we don't want to see in Post Content
        {...{
          background: undefined,
          sectionText: undefined,
          title: undefined,
        }}
        // Default to size S for Post Content Accordions
        accordionSize={ACCORDION_SIZES.S}
        useTextContainerWidth
      />
    </ContentBreakout>
  ),
  "ContentfulLpBespokeComponent": BespokeComponent,
  "ContentfulCta": (props: any) => (
    <ContentBreakout>
      <div className="container">
        <div className="grid">
          <div className="column column--2-12-L column--3-11-XL">
            <CTA {...props} isCompact />
          </div>
        </div>
      </div>
    </ContentBreakout>
  ),
  "ContentfulPost": (props: CardFragmentFragment) => (
    <ContentRelatedContent
      contentful_id={props.contentful_id}
      posts={[props]}
    />
  ),
}

const ContentBlockDIV = styled.div`
  width: 100%;

  &.ContentBlockVideo {
    padding-bottom: 1px;
  }
`

const ContentBlocks: FC<{ content: PostContentReferencesFragmentFragment[] }> = ({ content }) => {
  if (!content) return null

  const contentBlockName = content[0]?.__typename ? content[0].__typename.replace("Contentful", "") : ''

  return (
    <>
      {content.map((contentBlock) => {
        const Component = contentBlock?.__typename ? CONTENT_COMPONENTS[contentBlock.__typename] : null
        return (
          Component ? (
            <ContentBlockDIV
              className={`ContentBlocks ${contentBlockName}`}
              id={`ContentBlock--${contentBlock.contentful_id}`}
              key={`ContentBlock_${contentBlock.contentful_id}`}
            >
              <Component {...contentBlock} />
            </ContentBlockDIV>
          ) :
            null
        )
      })}
    </>
  )
}

export default ContentBlocks
